<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'Home' }">
        Mon compte
      </el-breadcrumb-item>

      <el-breadcrumb-item :to="{ name: 'Listes' }">
        Mes listes cadeau
      </el-breadcrumb-item>

      <el-breadcrumb-item>
        Création d'une liste cadeau
      </el-breadcrumb-item>
    </el-breadcrumb>

    <el-row v-if="!!profil">
      <el-col :span="24">
        <el-card
          shadow="never"
        >
          <template #header>
            <div class="vv-new-liste__title-wrapper">
              <span>Création d'une liste cadeau</span>
              <el-row
                class="vv-new-liste__steps-wrapper"
                style="flex-grow: 1;"
              >
                <el-steps
                  :active="0"
                  align-right
                >
                  <el-step
                    :status="steps.informations.status"
                    :title="steps.informations.title"
                  />
                  <el-step
                    :status="steps.beneficiaire.status"
                    :title="steps.beneficiaire.title"
                    :description="steps.beneficiaire.description"
                  />
                  <el-step
                    :status="steps.final.status"
                    :title="steps.final.title"
                  />
                </el-steps>
              </el-row>
            </div>
          </template>

          <div ref="wrapper">
            <!-- Informations générales -->
            <el-row v-if="steps.informations.status === 'process'">
              <ValidationObserver
                v-slot="{ passes }"
                ref="formInformationValidationObserver"
              >
                <el-form class="vv-new-liste__form">
                  <el-row>
                    <span class="vv-new-liste__steps-title">{{ steps.informations.title }}</span>
                  </el-row>
                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="evenement"
                        rules="required"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="J'organise cette liste pour"
                        >
                          <el-select
                            v-model="forms.informations.input.evenement"
                            placeholder="Séléctionnez un évènement"
                            :disabled="forms.informations.saving || underMaintenance"
                          >
                            <el-option
                              v-for="type in typesCagnotte"
                              :key="type.id"
                              :value="type.id"
                              :label="type.name"
                            />
                          </el-select>
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>

                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="libelle"
                        rules="required"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Appellation de la liste"
                        >
                          <el-input
                            v-model="forms.informations.input.libelle"
                            placeholder="Appellation"
                            :disabled="forms.informations.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="dateEvenement"
                        rules="required"
                      >
                        <div class="el-form-item__label el-form-item__label-has-icon">
                          <el-tooltip placement="top">
                            <div slot="content">
                              15 jours après cette date, les donateurs ne pourront plus participer et le bénéficiaire pourra utiliser la liste pour s'inscrire à un voyage au cours des 12 mois suivant.
                            </div>
                            <span class="el-icon-info" />
                          </el-tooltip>
                          Date de l'évèvenement
                        </div>
                        <el-form-item :error="errors[0]">
                          <el-date-picker
                            v-model="forms.informations.input.dateEvenement"
                            :picker-options="{
                              disabledDate: (t) => (t.getTime() < Date.now()) || (t.getTime() > new Date(new Date().setFullYear(new Date().getFullYear() + 1)))
                            }"
                            format="dd/MM/yyyy"
                            :disabled="forms.informations.saving || underMaintenance"
                            value-format="yyyy-MM-dd"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="selfBenef"
                        rules="required"
                      >
                        <el-form-item
                          label="Le bénéficiaire de la liste est"
                          :error="errors[0]"
                        >
                          <el-select
                            v-model="forms.informations.input.selfBenef"
                          >
                            <el-option
                              label="Une autre personne"
                              :value="false"
                            />
                            <el-option
                              label="Moi-même"
                              :value="true"
                            />
                          </el-select>
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col :span="24">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="conditions générales"
                        rules="accepted"
                      >
                        <el-form-item
                          class="el-form-item__has-checkbox"
                          :error="errors[0]"
                        >
                          <el-checkbox
                            v-model="forms.informations.input.conditionsAreAccepted"
                            :disabled="forms.informations.saving || underMaintenance"
                          />
                          <span class="el-checkbox__label">
                            J'ai lu et j'accepte <a
                              :href="cguUrl"
                              target="_blank"
                            >les conditions générales d'ouverture et d'utilisation d'une liste cadeau</a>
                          </span>
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>
                  <el-row type="flex">
                    <el-col
                      align="center"
                      :span="24"
                    >
                      <el-button
                        v-loading="forms.informations.saving"
                        size="small"
                        type="primary"
                        :disabled="forms.informations.saving || underMaintenance"
                        @click="passes(goToNextStep)"
                      >
                        Suivant
                        <i class="el-icon-arrow-right" />
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </ValidationObserver>
            </el-row>

            <!-- Bénéficiaire -->
            <el-row v-if="steps.beneficiaire.status === 'process'">
              <ValidationObserver
                v-slot="{ passes }"
                ref="formBeneficiaireValidationObserver"
              >
                <el-form class="vv-new-liste__form">
                  <el-row>
                    <span class="vv-new-liste__steps-title">{{ steps.beneficiaire.title }}</span>
                  </el-row>
                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col :span="24">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.civilite"
                        rules="required"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Civilité *"
                        >
                          <el-radio-group v-model="forms.beneficiaire.input.civilite">
                            <el-radio
                              v-for="civilite in civilites"
                              :key="civilite.id"
                              :label="civilite.id"
                              :disabled="forms.beneficiaire.saving || underMaintenance"
                            >
                              {{ civilite.name }}
                            </el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.nomClient"
                        rules="required|max:32"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Nom *"
                        >
                          <el-input
                            v-model="forms.beneficiaire.input.nomClient"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>

                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.prenomClient"
                        rules="required|max:32"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Prénom *"
                        >
                          <el-input
                            v-model="forms.beneficiaire.input.prenomClient"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.dateNaissance"
                        rules="required"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Date de naissance *"
                        >
                          <el-date-picker
                            v-model="forms.beneficiaire.input.dateNaissance"
                            :picker-options="{
                              disabledDate: (t) => (t.getTime() > new Date())
                            }"
                            format="dd/MM/yyyy"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                            value-format="yyyy-MM-dd"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>

                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.email"
                        :rules="`required|email|is_not:${profil.email}`"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Adresse email (aucun email ne sera envoyé au bénéficiaire de la liste) *"
                        >
                          <el-input
                            v-model="forms.beneficiaire.input.email"
                            label="Adresse email"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.adresse"
                        rules="required|address"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Adresse *"
                        >
                          <el-input
                            v-model="forms.beneficiaire.input.adresse"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                            value-format="dd/MM/yyyy"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>

                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.adresse2"
                        rules="address"
                      >
                        <el-form-item
                          label="Complément d'adresse"
                          :error="errors[0]"
                        >
                          <el-input
                            v-model="forms.beneficiaire.input.adresse2"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.codePostal"
                        rules="required|postcode"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Code postal *"
                        >
                          <el-input
                            v-model="forms.beneficiaire.input.codePostal"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>

                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.ville"
                        rules="required|city"
                      >
                        <el-form-item
                          label="Ville *"
                          :error="errors[0]"
                        >
                          <el-input
                            v-model="forms.beneficiaire.input.ville"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.pays"
                        rules="required"
                      >
                        <el-form-item
                          :error="errors[0]"
                          label="Pays *"
                        >
                          <el-select
                            v-model="forms.beneficiaire.input.pays"
                          >
                            <el-option-group
                              v-for="group in paysGroupe"
                              :key="group.label"
                            >
                              <el-option
                                v-for="p in group.options"
                                :key="p.iso"
                                :label="p.nom"
                                :disabled="forms.beneficiaire.saving || underMaintenance"
                                :value="p.iso"
                              />
                            </el-option-group>
                          </el-select>
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.mobile"
                        :rules="{ required: true, phone: forms.beneficiaire.input.pays ? forms.beneficiaire.input.pays.iso : null }"
                      >
                        <el-form-item
                          label="Numéro de téléphone portable *"
                          :error="errors[0]"
                        >
                          <input-phone
                            v-model="forms.beneficiaire.input.mobile"
                            :country="forms.beneficiaire.input.pays || ''"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>

                    <el-col
                      :xs="24"
                      :md="12"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="beneficiaire.telephone"
                        :rules="{ required: false, phone: forms.beneficiaire.input.pays ? forms.beneficiaire.input.pays.iso : null }"
                      >
                        <el-form-item
                          label="Numéro de téléphone fixe"
                          :error="errors[0]"
                        >
                          <input-phone
                            v-model="forms.beneficiaire.input.telephone"
                            :country="forms.beneficiaire.input.pays || ''"
                            :disabled="forms.beneficiaire.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row />

                  <el-row
                    type="flex"
                  >
                    <el-col
                      align="left"
                      :span="12"
                    >
                      <el-button
                        v-loading="forms.beneficiaire.saving"
                        size="small"
                        :disabled="underMaintenance || forms.beneficiaire.saving"
                        tabindex="-1"
                        @click="goToPreviousStep"
                      >
                        <i class="el-icon-arrow-left" />
                        Précédent
                      </el-button>
                    </el-col>
                    <el-col
                      align="right"
                      :span="12"
                    >
                      <el-button
                        v-loading="forms.beneficiaire.saving"
                        size="small"
                        type="primary"
                        :disabled="underMaintenance || forms.beneficiaire.saving"
                        @click="passes(goToNextStep)"
                      >
                        Suivant
                        <i class="el-icon-arrow-right" />
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </ValidationObserver>
            </el-row>

            <!-- Personnalisation -->
            <el-row v-if="steps.final.status === 'process'">
              <ValidationObserver
                v-slot="{ passes }"
                ref="formFinalValidationObserver"
              >
                <el-form class="vv-new-liste__form">
                  <el-row>
                    <span class="vv-new-liste__steps-title">{{ steps.final.title }}</span>
                  </el-row>
                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col :span="24">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="texte page Web"
                        rules="max:1500"
                      >
                        <el-form-item
                          label="Créez votre texte de présentation de la liste à destination des participants (1 500 caractères max.)"
                          :error="errors[0]"
                        >
                          <el-input
                            v-model="forms.final.input.textePageWeb"
                            :placeholder="'Bonjour à toutes et à tous,\n\nVous pouvez participer ci-dessous à cette liste cadeau, ouverte pour offrir un voyage à...'"
                            rows="10"
                            type="textarea"
                            :disabled="forms.final.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    :gutter="20"
                    type="flex"
                  >
                    <el-col :span="24">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="montantVisibleWeb"
                        rules="required"
                      >
                        <el-form-item
                          :error="errors[0]"
                        >
                          <el-checkbox
                            v-model="forms.final.input.montantVisibleWeb"
                            label="Montrer le montant total collecté aux participants de la liste"
                            :disabled="forms.final.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                    <el-col :span="24">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="sendNotif"
                        rules="required"
                      >
                        <el-form-item
                          :error="errors[0]"
                        >
                          <el-checkbox
                            v-model="forms.final.input.sendNotif"
                            label="Je recevrai une notification par email à chaque participation"
                            :disabled="forms.final.saving || underMaintenance"
                          />
                        </el-form-item>
                      </ValidationProvider>
                    </el-col>
                  </el-row>

                  <el-row
                    type="flex"
                  >
                    <el-col
                      align="left"
                      :span="12"
                    >
                      <el-button
                        v-loading="forms.final.saving"
                        size="small"
                        :disabled="underMaintenance || forms.final.saving"
                        tabindex="-1"
                        @click="goToPreviousStep"
                      >
                        <i class="el-icon-arrow-left" />
                        Précédent
                      </el-button>
                    </el-col>
                    <el-col
                      align="right"
                      :span="12"
                    >
                      <el-button
                        v-loading="forms.final.saving"
                        size="small"
                        type="primary"
                        :disabled="underMaintenance"
                        @click="passes(createCagnotte)"
                      >
                        Créer
                      </el-button>
                    </el-col>
                  </el-row>
                </el-form>
              </ValidationObserver>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// Librairies
import { mapGetters } from 'vuex'
import WEBSITE_URLS from '@/services/website-target'

export default {
  data () {
    return {
      forms: {
        informations: {
          saving: false,
          input: {
            libelle: null,
            evenement: null,
            selfBenef: false,
            conditionsAreAccepted: false,
            dateEvenement: null
          }
        },
        beneficiaire: {
          saving: false,
          input: {
            civilite: null,
            nomClient: null,
            prenomClient: null,
            dateNaissance: null,
            email: null,
            adresse: null,
            adresse2: '',
            codePostal: null,
            ville: null,
            pays: null,
            telephone: null,
            mobile: null
          }
        },
        final: {
          saving: false,
          input: {
            sendNotif: true,
            montantVisibleWeb: false,
            textePageWeb: ''
          }
        }
      },
      steps: {
        active: 0,
        informations: {
          status: 'process',
          title: 'Informations générales',
          description: null
        },
        beneficiaire: {
          status: 'wait',
          title: 'Coordonnées du bénéficiaire',
          description: null // 'Nous connaissons le bénéficiaire'
        },
        final: {
          status: 'wait',
          title: 'Personnalisation',
          description: null
        }
      }
    }
  },

  computed: {
    ...mapGetters(['profil', 'pays', 'underMaintenance', 'civilites', 'typesCagnotte']),

    paysGroupe () {
      if (!this.pays) {
        return [[], []]
      }

      const paysA = { label: 'Groupe A', options: [] }
      const paysB = { label: 'Groupe B', options: [] }
      this.pays.forEach(element => {
        if (element.iso === 'FR') {
          paysA.options.push(element)
        } else {
          paysB.options.push(element)
        }
      })
      return [paysA, paysB]
    },

    cguUrl () {
      return WEBSITE_URLS.giftlistCGU
    }
  },

  created () {
    // Démarre l'indicateur de chargement
    this.$store.commit('startLoading')

    // Récupère les données utilisées par la vue
    Promise.all([
      this.$store.dispatch('getUserInfos'),
      this.$store.dispatch('getSystemStatus'),
      this.$store.dispatch('getAgences'),
      this.$store.dispatch('getPays')
    ])
      .then(() => {
        if (this.underMaintenance) {
          // Envoi une notification
          this.$message({
            duration: 5000,
            message: 'La création de liste cadeau est momentanément indisponibles en raison d\'activité de maintenance.',
            showClose: true,
            type: 'info'
          })

          // Redirige vers la page de la nouvelle liste
          this.$router.push({ name: 'Listes' })
        }
      })
      .finally(() => {
        // Stop l'indicateur de chargement
        this.$store.commit('stopLoading')
      })
  },

  methods: {
    createCagnotte () {
      this.forms.final.saving = true

      // Prépare les informations de la liste
      const payload = { ...this.forms.informations.input, ...this.forms.final.input }
      payload.montantVisibleBon = this.forms.informations.input.selfBenef

      if (!this.forms.informations.input.selfBenef) { // Ajoute les informations du bénéficiaire s'il est différent du créateur
        payload.beneficiaireForm = { ...this.forms.beneficiaire.input }
      }

      this.$store.dispatch('createListe', payload)
        .then((id) => {
          // Envoi une notification
          this.$message({
            duration: 5000,
            message: 'Liste cadeau créée avec succès',
            showClose: true,
            type: 'success'
          })

          // Redirige vers la page de la nouvelle liste
          this.$router.push({ name: 'Liste', params: { id: id }, query: { created: true } })
        })
        .finally(() => {
          this.forms.final.saving = false
        })
    },

    goToNextStep () {
      if (this.steps.informations.status === 'process') {
        this.$refs.formInformationValidationObserver.reset()

        if (this.forms.informations.input.selfBenef) {
          this.steps.informations.status = 'success'
          this.steps.beneficiaire.status = 'success'
          this.steps.final.status = 'process'
          this.steps.beneficiaire.description = 'Vous êtes le bénéficiaire'
        } else {
          this.steps.informations.status = 'success'
          this.steps.beneficiaire.status = 'process'
          this.steps.final.status = 'wait'
          this.steps.beneficiaire.description = null
        }
      } else if (this.steps.beneficiaire.status === 'process') {
        this.$refs.formBeneficiaireValidationObserver.reset()
        this.steps.informations.status = 'success'
        this.steps.beneficiaire.status = 'success'
        this.steps.final.status = 'process'
      }

      this.scrollToFormTop()
    },

    goToPreviousStep () {
      if (this.steps.beneficiaire.status === 'process') {
        this.$refs.formBeneficiaireValidationObserver.reset()

        this.forms.beneficiaire.input = {
          civilite: null,
          nomClient: null,
          prenomClient: null,
          dateNaissance: null,
          email: null,
          adresse: null,
          adresse2: '',
          codePostal: null,
          ville: null,
          pays: null,
          telephone: null,
          mobile: null
        }

        this.steps.informations.status = 'process'
        this.steps.beneficiaire.status = 'wait'
        this.steps.final.status = 'wait'
      } else if (this.steps.final.status === 'process') {
        this.$refs.formFinalValidationObserver.reset()

        this.forms.final.input = {
          sendNotif: true,
          textePageWeb: '',
          montantVisibleWeb: false
        }

        if (this.forms.informations.input.selfBenef) {
          this.steps.informations.status = 'process'
          this.steps.beneficiaire.status = 'wait'
          this.steps.beneficiaire.description = null
          this.steps.final.status = 'wait'
        } else {
          this.steps.informations.status = 'success'
          this.steps.beneficiaire.status = 'process'
          this.steps.final.status = 'wait'
        }
      }

      this.scrollToFormTop()
    },

    scrollToFormTop () {
      setTimeout(() => {
        if (window.screen.availWidth <= 991) {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
          window.scrollTo({ top: this.$refs.wrapper.getBoundingClientRect().top - 100 + window.pageYOffset, behavior: 'smooth' })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .vv-new-liste {
    &__selfBenef {
      &-wrapper {
        display: flex;
        align-items: center;
      }
    }

    &__dateEvenement {
      &-info {
        margin-bottom: 1rem;
        &-wrapper {
          display: flex;
          align-items: flex-end;
        }
      }
    }

    &__steps {
      &-wrapper {
        margin-left: 15rem;

        @media only screen and (max-width: 1750px) {
          margin-left: 10rem;
        }

        @media only screen and (max-width: 1500px) {
          margin-left: 2.5rem;
        }

        @media only screen and (max-width: 1200px) {
          margin-left: 0;
          margin-top: 1rem;
        }

        @media only screen and (max-width: 768px) {
          display: none;
        }
      }

      &-title {
        font-size: 1.5rem;
        color: #282a33;
        display: block;
        margin-top: 1rem;
        margin-bottom: 1rem;
      }
    }

    &__title {
      &-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;

        @media only screen and (max-width: 1200px) {
          flex-direction: column;
          align-items: stretch;
        }
      }
    }

    &__form {
      padding: 0;
      // padding: 0 20px;
    }

    &__textePageWeb {
      &-info {
        margin-bottom: 1rem;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    .el-col-xs-24:not(:first-child) {
      margin-top: 20px;
    }
  }
</style>
